module.exports = __webpack_public_path__ + "img/logo-plataforma-aj-linea-blanco-negro-md.b6e51524.png";